import MyAxios from "@/utilize/MyAxios";
import { useMutation } from "@tanstack/react-query";

interface IPayload {
  organizationId: string;
}

interface IResponse {
  redirectUrl: string;
  accessToken: string;
  refreshToken: string;
}

const UseLoginToOrganization = () => {
  return useMutation({
    mutationKey: ["organization-login"],
    mutationFn: (payload: IPayload) =>
      MyAxios.post<IResponse>("/organizations/login", payload),
  });
};

export default UseLoginToOrganization;
